import { Breadcrumbs, Link, Typography } from "@mui/material";
import cx from "classnames";
import { ReactNode } from "react";
import "./breadcrumb.css";

type crumbValue = {
  name: string;
  link?: string;
};

type breadCrumbProps = {
  props: ReadonlyArray<crumbValue>;
  firstCrumbName?: string;
  firstCrumbLink?: string;
  disable?: boolean;
  variant?: "default" | "municipios";
  rightElement?: ReactNode;
};

export default function BreadCrumbGeneric(c: Readonly<breadCrumbProps>) {
  if (c.disable) {
    return <></>;
  }
  const firstCrumb = (
    <Link
      underline="none"
      color="inherit"
      href={c.firstCrumbLink ?? `${process.env.PORTAL_URL}`}
    >
      {c.firstCrumbName ?? "Início"}
    </Link>
  );

  return (
    <div
      className={cx("breadcrumb-content", {
        [`breadcrumb-content--${c.variant}`]: !!c.variant,
      })}
    >
      <div
        className={cx("xvia-container breadcrumb-info_container", {
          "breadcrumb-info_container--with-action": !!c.rightElement,
        })}
      >
        <Breadcrumbs
          aria-label="breadcrumb"
          className={cx("breadcrumb", {
            [`breadcrumb--${c.variant}`]: !!c.variant,
          })}
        >
          {firstCrumb}
          {c.props.map((value, index) =>
            index === c.props.length - 1 ? (
              <Typography
                key={`${value.name}-${index}`}
                className={cx("breadcrumb", {
                  [`breadcrumb--${c.variant}`]: !!c.variant,
                })}
              >
                {value.name}
              </Typography>
            ) : (
              <Link
                key={`${value.name}-${index}`}
                underline="none"
                color="inherit"
                href={value.link}
              >
                {value.name}
              </Link>
            )
          )}
        </Breadcrumbs>
        {c.rightElement}
      </div>
    </div>
  );
}
